<template>
    
    <div class="main">
        <form-servidor :paramId="$route.params.id" v-on:onSubmitServidor="onSubmitServidor"></form-servidor>
    </div>
    
</template>
<script>

import formServidor from "./form"

export default {
    methods:{

        onSubmitServidor(){

            this.$router.push('/admin/servidor');  
        }
    },
    components:{ formServidor }
}
</script>
